const tooltipData = {
  transactionType:
    "The Transaction Type will determine the prepopulated Tasks on the Transaction Timeline.",
  region:
    "Region is automatically determined based on the country and corresponds to JLL's regional mapping.",
  busUnit: "Please enter NA if not applicable.",
  desks: "Enter Number of allocated desks.",
  members: "Number of members assigned to the Flex Agreement.",
  maxHeadcount: "Number of members allowed in the space at any one time.",
  localUnitOfM:
    "Automatically populated based on the Country but can be changed.",
  localCurrency:
    "Automatically populated based on the Country but can be changed.",
  currTransactionArea:
    "Rentable area of the lease for a leasing transaction or area of the transacted property for a freehold transaction.",
  currTransactionCost:
    "Annual rent for a leasing transaction or total cost of a freehold transaction.",
  rentCostPerArea:
    "Rental cost of the lease per area and per period for a leasing transaction.",
  nonRentCostPerArea:
    "Additional costs (such as service charge, management fees etc) of the lease per area and per period for a leasing transaction.",
  reinstatementCost: "Initial indicative reinstatement liability",
  netFee: "Gross commission or revenue less any client discount or rebate.",
  totalFee: "Gross commission or revenue due to JLL.",
  clientDiscountRebate: "If applicable",
  netRevenueToTm: "Based on agreed internal fee share percentage.",
  targetRentCostPerArea:
    "If available - estimated rental costs of the lease per area and per period for a leasing transaction.",
  targetNonRentCostPerArea:
    "If available - estimated additional costs (such as service charge, management fees etc) of the lease per area and per period for a leasing transaction.",
  transactionStartDate:
    "Transaction Start Date is automatically populated based on the start date of the earliest Task in the Transaction Timeline.",
  transactionEndDate:
    "Transaction End Date is automatically populated based on the end date of the latest Task in the Transaction Timeline.",
  transactionDueDate:
    "Transaction Due Date is automatically populated based on the due date of the latest Step in the Transaction Timeline.",
  transactionScore:
    "Please enter a number 0.00 to 5.00 based on Broker KPI Score.",
  patClientId:
    "Should match the PAT Client ID value as it is used for ETL purposes to get Lease Admin data from PAT into Tracker",
  securityGroupName:
    "Primary Security Group Name associated with the TAT Client",
  securityGroupId:
    "Should match the TAT Security Group ID as this will be used for authorization",
  tmEmail: "Please enter 3 or more characters to search a user",
  brokerEmail: "Please enter 3 or more characters to search a user",
  userEmailAddress: "Please enter 3 or more characters to search a user",
  state: "To enter state, you must select country first.",
  city: "To enter city, you must select state first.",
  address1: "To enter address, you must select city first.",
  longitude: "This information is based on the address you entered.",
  latitude: "This information is based on the address you entered.",
};

export default tooltipData;
